export default __webpack_public_path__ + "static/nathan-dumlao-LPRrEJU2GbQ-unsplash-8fe1646b16f442fa3d387a5eadb7dfa5.jpg";